import { defineMessages } from "react-intl";

import { node as anthropometrics } from "src/modules/ktx/forms/basic-registration-data/clinical-data/anthropometrics";
import { node as bloodGroup } from "src/modules/ktx/forms/basic-registration-data/clinical-data/bloodGroup";
import { node as preImmunisation } from "src/modules/ktx/forms/basic-registration-data/clinical-data/pre-immunisation";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "ktx.clinical_data",
		defaultMessage: "Klinikai adatok"
	}
});

export const node: ParentNode = {
	id: "ktx-clinical-data",
	value: { type: "wizard", title: messages.title },
	children: [anthropometrics, bloodGroup, preImmunisation]
};
